/* eslint-disable camelcase */
import React from 'react'
import PropTypes from 'prop-types'
import { Steps } from 'shpmtcd'
import { ClickedOntrackinglink as GA_ClickedOnLink } from '../../../Analytics/googleAnalytics'
import { ClickedOntrackinglink as FB_ClickedOnLink } from '../../../Analytics/facebook'

import {
  Ordered,
  Canceled,
  Returned,
  Delivered,
  InTransit,
  Refunded,
  TrackStatus,
  Description,
} from './components'

const shipmentProviderName = (shipmentProvider) => {
  switch (shipmentProvider) {
    case 'ninjavan':
      return 'Ninja Van'
    case 'easyship':
      return 'Easyship'
    case 'shipyaari':
      return 'Shipyaari'
    default:
      return ''
  }
}

export const ShippingPartnerStatus = ({
  shipment_provider, tracking_number, tracking_link,
  status, ordered_date, order_id, in_transit_date, delivered_date,
  expected_delivery,
}) => {
  let currentStatus
  let orderSteps = []
  // get each step component
  const Order = Ordered(ordered_date, order_id)
  const inTransit = InTransit(in_transit_date)
  const Cancel = Canceled(delivered_date)
  const Return = Returned(delivered_date, status === 'returned')
  const Refund = Refunded(delivered_date, status === 'refunded')
  const Delivery = Delivered(delivered_date, status === 'delivered')
  // get provider name
  const shippingPartnerName = shipmentProviderName(shipment_provider)
  // get steps order
  const StepsToShow = () => {
    switch (status) {
      case 'cancelled':
        currentStatus = 1
        orderSteps = [Order, Cancel]
        break
      case 'in_transit':
        currentStatus = 1
        orderSteps = [Order, inTransit, Delivery]
        break
      case 'returned':
        currentStatus = 1
        orderSteps = [Order, Return]
        break
      case 'refunded':
        currentStatus = 1
        orderSteps = [Order, Refund]
        break
      case 'delivered':
        currentStatus = 1
        orderSteps = [Order, Delivery]
        break
      default:
        currentStatus = 0
        orderSteps = [Order, Delivery]
        break
    }
  }
  StepsToShow()
  // in_transit to be shown if the end is not reached
  if (shippingPartnerName.length && (status === 'ordered')) {
    orderSteps.splice(1, 0, inTransit)
  }

  return (
    <>
      <section className={orderSteps.length > 2
        ? 'order-status-steps-wrapper'
        : 'order-status-steps-wrapper two-steps'}
      >
        <Steps current={currentStatus}>
          {orderSteps.map((x) => x.steps)}
        </Steps>
      </section>
      <section className='order-status-desc-wrapper'>
        {orderSteps.map((x) => x.desc)}
        {expected_delivery ? (
          <Description
            label='Expected delivery'
            value={expected_delivery}
          />
        ) : null}
        {
          shipment_provider !== 'self_collect'
            ? (
              <section>
                {
                status !== 'canceled'
                  ? (
                    <TrackStatus
                      partner={shippingPartnerName}
                      trackNumber={tracking_number}
                      link={tracking_link}
                      onClickCallback={() => {
                        GA_ClickedOnLink(order_id, status)
                        FB_ClickedOnLink(order_id, status)
                      }}
                    />
                  )
                  : null
              }
              </section>
            )
            : null
        }
      </section>
    </>
  )
}

ShippingPartnerStatus.propTypes = {
  shipment_provider: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  ordered_date: PropTypes.string.isRequired,
  in_transit_date: PropTypes.string,
  delivered_date: PropTypes.string,
  order_id: PropTypes.string.isRequired,
  tracking_number: PropTypes.string,
  tracking_link: PropTypes.string,
  expected_delivery: PropTypes.string,
}

ShippingPartnerStatus.defaultProps = {
  in_transit_date: 'Not Available',
  delivered_date: 'Not Available',
  expected_delivery: null,
  tracking_number: null,
  tracking_link: null,
}
